const initialState = {
    registerDate: '',
    userName: '',
    mobile: '',
    address: '',
    productPrice: '',
    totalDiscount: '',
    shippingPrice: '',
    consignments: [],

    content: {},
};
const orderDetails = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_USER_ORDER_DETAILS':
            return {...state, [action.name]: action.value};
       	
        default:
            return state;
    }
};

export default orderDetails;
